import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
  systemname: '',
  CompanyName: '',
  CompanyNameEnglish: '',
  token: {
    withCredentials: true,
    headers: {
      token: '',
      nickname: ''
    }
  },
  mrrouter: {
    name: undefined,
    path: '/HomePage/gztj_zzjg',
    title: '组织机构'
  },
  imgURl: 'http://192.168.14.4:8002/dp-hd/',
  loginstatus: localStorage.getItem('loginstatus') || false, // 路由状态
  username: '',
  nickname: '',
  usernameID: ''
}
const mutations = {
  setRouting(state, loginstatus) {
    state.loginstatus = loginstatus
    localStorage.setItem('loginstatus', loginstatus)
  },
  modifyTitle(state, title) {
    state.systemname = title
  }
}

export default new Vuex.Store({
  state,
  mutations,
  plugins: []
})
Vue.prototype.checkNulla = function (a) {
  if (a == null || a == '') {
    return false
  } else {
    return true
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js